// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3WylW","label":"Completed_label__k6PMs"};